import { checkStgUrl } from '../../utils/bookingUtils';

export default {
    items: [
        {
            value: 'A',
            path: '/booking/vehicle',
            headText: 'Vehicle Booking',
            description: '',
            icon: 'car',
            color: 'orange',
            roleView: [true, false],
            onProd: checkStgUrl(globalThis.location.href, false)
        },
        {
            value: 'B',
            path: '/booking/pr',
            headText: `Service by Media Development Section`,
            description: '',
            icon: 'picture',
            color: '#4C6793',
            roleView: [true, false],
            onProd: checkStgUrl(globalThis.location.href, false)
        },
    ]
}
